<template>
  <div>
    <!-- PÁGINA DE LOGIN -->
    <div v-if="telaLogin" class="limiter">
      <div class="container-login100">
        <div class="wrap-login100">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-card class="login100-form" flat style="border-radius: 15px;">
                <span class="login100-form-title">
                  <img src="../../assets/logo_roxa.png" width="200px">
                </span>
                <v-card-text>
                  <v-layout row wrap justify-center>
                    <v-flex xs10 sm10 lg9>
                      <v-text-field
                        color="#7B1FA2"
                        label="CPF do Lojista"
                        single-line
                        outlined
                        dense
                        v-model="cpfLojista"
                        required
                        prepend-inner-icon="person"
                        @keydown.enter="entrar"
                        v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular"
                      />
                    </v-flex>
                    <br>
                    <v-flex xs10 sm10 lg9>
                      <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="entrar">Acessar</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-row>
            <br>
            <div class="login100-form-title">
              <a href="https://www.intelitetecnologia.com.br/" target="_blank">
                <img src="../../assets/logoAIPassIntelite.png" width="250px">
              </a>
            </div>
            <br>
          </v-container>
        </div>
      </div>
    </div>
    <!-- FIM DA PÁGINA DE LOGIN -->

    <!-- PÁGINA DO VÍDEO -->
    <div v-if="usuarioLogado">
      <v-img
        max-width="100%"
        height="100%"
        class="grey darken-4"
        style="background-color: #f6ee5e;"
      >
        <div style="padding: 30px 50px;">
          <h3 style="color: #fff">Bem vindo(a), {{primeiroUltimoNome(lojista.nome)}}!</h3>
          <v-btn dark depressed outlined color="#FFFFFF" style="border-radius: 7px;" @click="sair">
            <v-icon left>logout</v-icon>
            Sair
          </v-btn>
        </div>
      </v-img>
      <v-container fluid grid-list-md>
        <v-row style="text-align: right" right>
          <v-col lg="2">
            <v-btn dark color="green" block @click="criarVenda">
              <v-icon left>add</v-icon>Nova Venda
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" class="elevation-1" style="border-radius: 10px;">
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TRANSAÇÕES</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma transação localizada</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.statusPagamento`]="{ item }">
            <v-chip v-if="item.statusPagamento == 'PENDENTE'" color="orange" dark>{{ item.statusPagamento }}</v-chip>
            <v-chip v-if="item.statusPagamento == 'PAGO'" color="green" dark>{{ item.statusPagamento }}</v-chip>
            <v-chip v-if="item.statusPagamento == 'CANCELADO'" color="red" dark>{{ item.statusPagamento }}</v-chip>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            <td>R$ {{ item.valor }}</td>
          </template>
          <template v-slot:[`item.codigoTransacao`]="{ item }">
            <td><a :href="item.codigoTransacao" target="_blank" style="text-decoration: none">Visualizar</a></td>
          </template>
        </v-data-table>
      </v-container>
      <v-footer color="#4A148C" width="auto" style="justify-content: center;">
        <p class="textofooter">COPYRIGHT © 2022 - AIPASS INTELITE</p>
        <v-spacer></v-spacer>
        <v-btn icon dark href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
          <img src="../../assets/instagram.png">
        </v-btn>
      </v-footer>
    </div>
    <!-- FIM DA PÁGINA DO VÍDEO -->

    <v-dialog persistent scrollable v-model="dialogoCriaVenda" max-width="700px">
      <v-card>
        <v-card-title>Nova Venda</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p style="margin-bottom: 5px">Informações dos ingressos</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="12">
                <v-text-field :value="evento.nome + ' - R$ ' + evento.valor" outlined label="Nome do Evento" color="#7B1FA2" dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="12">
                <v-text-field :value="'Lote ' + evento.lote" outlined color="#7B1FA2" dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="12">
                <v-select v-model="transacao.quantidadeInscricoes" outlined label="Quantidade de Ingressos*" color="#7B1FA2" :items="quantidade" hide-details item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="12" v-if="transacao.quantidadeInscricoes">
                <v-text-field :value="transacao.quantidadeInscricoes + ' x R$ ' + evento.valor + ' = R$ ' + (parseFloat(evento.valor.replace(',','.')) * transacao.quantidadeInscricoes).toFixed(2).replace('.',',')" outlined solo color="#7B1FA2" dense hide-details readonly></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="fechaDialogo" text color="red">Fechar</v-btn>
          <v-btn @click="pagarPix" :disabled="!transacao.quantidadeInscricoes" text color="primary">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pagamentoPix" persistent max-width="600px">
      <v-card style="border-radius: 10px;">
        <v-card-text style="text-align: center;padding:0 24px 0;">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                <p class="texto" style="color: #00695C" v-if="transacao.quantidadeInscricoes == 1">{{ transacao.quantidadeInscricoes }} ingresso para {{ evento.nome }}</p>
                <p class="texto" style="color: #00695C" v-if="transacao.quantidadeInscricoes > 1">{{ transacao.quantidadeInscricoes }} ingressos para {{ evento.nome }}</p>
              </v-col>
              <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                <p class="texto" style="color:orange" v-if="evento.valor">R$ {{(parseFloat(evento.valor.replace(',','.')) * transacao.quantidadeInscricoes).toFixed(2).replace('.',',')}}</p>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                <img :src="qrCode64" width="100%" style="max-width: 300px">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="cancelaPagamento">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card style="border-radius: 10px;">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="texto">{{msgResultado}}</span>
        </v-card-title>
        <v-card-text style="text-align: center; padding: 0 24px 0;">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto">{{evento.nome}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto" style="background-color: #D32F2F; color: white;" v-if="transacao.quantidadeInscricoes == 1">Ingresso para {{transacao.quantidadeInscricoes}} participante</p>
                <p class="texto" style="background-color: #D32F2F; color: white;" v-if="transacao.quantidadeInscricoes > 1">Ingresso para {{transacao.quantidadeInscricoes}} participantes</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <Loading :active.sync="isLoading" :can-cancel="true" color="#784e9b" :is-full-page="fullPage"></Loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css'
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import moment from 'moment'
  import { mapState } from 'vuex'
    export default {
      components: {Snackbar, Loading},
      data () {
        return {
          timeout: 4000,
          snackbar: false,
          textoSnackbar: '',
          cpfLojista: '',
          eventoLojista: '',
          eventos: [],
          telaLogin: true,
          lojista: [],
          cpf: '',
          idLojista: '',
          emailLojista: '',
          usuarioLogado: false,
          isLoading: false,
          fullPage: false,
          tabela: {
            busca: '',
            cabecalho: [
              { text: 'Valor', value: 'valor' },
              { text: 'Quantidade de Ingressos', value: 'quantidadeInscricoes', },
              { text: 'Status', value: 'statusPagamento' },
              { text: 'Lote', value: 'lote' },
              { text: 'Comprovante', value: 'codigoTransacao' },
            ],
            conteudo: [],
          },
          dialogoCriaVenda: false,
          clienteAsaas: {
            name: '',
            cpfCnpj: '',
            email: '',
            mobilePhone: '',
            postalCode: '',
            addressNumber: '',
            notificationDisabled: true,
          },
          cobrancaAsaas: {
            customer: '',
            billingType: '',
            value: 0,
            dueDate: '',
            description: ''
          },
          transacao: {
            valor: '',
            quantidadeInscricoes: null,
            statusPagamento: 'PENDENTE',
            lote: '',
            divulgadorId: '',
            eventoId: '',
          },
          quantidade: [],
          evento: [],
          chaveCopiaeCola: '',
          pagamentoPix: false,
          msgResultado: '',
          qrCode64: '',
          dialog: false,
        }
      },

      computed: mapState({
        // usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),

      async mounted () {
        var vm = this;
        if (localStorage.getItem("cpfLojista")) {
          this.isLoading = true
          await axios.get(baseApiUrl + 'Divulgadores/count?where={"cpf":"' + localStorage.getItem("cpfLojista") + '"}').then(async response => {
            if (response.data.count == 1) {
              await axios.get(baseApiUrl + 'Divulgadores?filter={"where":{"cpf":"' + localStorage.getItem("cpfLojista") + '"}}').then(result => {
                if (result.data[0].ativo) {
                  this.lojista = result.data[0]
                  this.clienteAsaas.name = this.lojista.nome
                  this.clienteAsaas.cpfCnpj = this.lojista.cpf
                  this.clienteAsaas.mobilePhone = this.lojista.celular.replace(/[^\d]+/g,'')
                  this.clienteAsaas.empresaId = this.lojista.empresaId
                  this.telaLogin = false
                  this.usuarioLogado = true
                  this.isLoading = false
                  this.buscaTransacoes()
                  this.pegaEvento(this.lojista.eventoId)
                } else {
                  vm.$refs.chamaSnackbar.snack("#F9A825","Lojista com situação não ativa","ATENÇÃO");
                  this.telaLogin = true
                  this.usuarioLogado = false
                  localStorage.removeItem("cpfLojista")
                }
              })
            } else {
              this.telaLogin = true
              this.usuarioLogado = false
            }
          })
        }
      },

      methods: {
        doCopy(id) {
          try {
            let copyText = document.getElementById(id);
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
            document.execCommand("copy");
            this.snackbar = true
            this.textoSnackbar = 'Chave copiada para a área de transferência!'
          } catch (error) {
            this.snackbar = true
            this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
          }
        },

        async entrar() {
          var vm = this;
          if (this.cpfLojista == '') {
            vm.$refs.chamaSnackbar.snack("#F9A825","Informe o CPF do lojista","ATENÇÃO");
          } else if(!CpfValidate(this.cpfLojista)) {
            vm.$refs.chamaSnackbar.snack("#F9A825","CPF informado é inválido","ATENÇÃO");
          } else {
            this.isLoading = true
            try {
              await axios.get(baseApiUrl + 'Divulgadores?filter={"where":{"cpf":"' + this.cpfLojista + '"}}').then(response => {
                if (response.data.length > 0) {
                  if (response.data[0].ativo) {
                    localStorage.setItem("cpfLojista", this.cpfLojista)
                    this.lojista = response.data[0]
                    this.clienteAsaas.name = this.lojista.nome
                    this.clienteAsaas.cpfCnpj = this.lojista.cpf
                    this.clienteAsaas.mobilePhone = this.lojista.celular.replace(/[^\d]+/g,'')
                    this.clienteAsaas.empresaId = this.lojista.empresaId
                    this.telaLogin = false
                    this.usuarioLogado = true
                    this.isLoading = false
                    this.buscaTransacoes()
                    this.pegaEvento(this.lojista.eventoId)
                  } else {
                    vm.$refs.chamaSnackbar.snack("#F9A825","Lojista com situação não ativa","ATENÇÃO");
                  }
                } else {
                  this.isLoading = false
                  vm.$refs.chamaSnackbar.snack("#F9A825","Lojista não localizado","ATENÇÃO");
                }
              })
            } catch (error) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao buscar lojista","DESCULPE");
            }
          }
        },

        primeiroUltimoNome(nome) {
          var nomeSeparado = nome.trim().split(" ")
          return nomeSeparado[0] + ' ' + nomeSeparado[nomeSeparado.length - 1]
        },

        async sair() {
          this.isLoading = true
          try {
            this.usuarioLogado = false
            this.telaLogin = true
            this.lojista = []
            this.isLoading = false
            localStorage.removeItem("cpfLojista")
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao efetuar logout, tente novamente","DESCULPE");
          }
        },

        async buscaTransacoes() {
          this.isLoading = true
          this.tabela.conteudo = []
          await axios.get(baseApiUrl + 'Transacaos?filter={"where":{"and":[{"eventoId":"' + this.lojista.eventoId + '"},{"divulgadorId":"' + this.lojista.id + '"}]}}').then(response => {
            if (response.data.length > 0) {
              this.tabela.conteudo = response.data
            }
            this.isLoading = false
          })
        },

        async pegaEvento(id) {
          await axios.get(baseApiUrl + 'eventos/' + id + '?filter={"fields":{"nome": true, "id": true, "valor": true, "lote": true, "acrescimoPix": true}}').then(response => {
            if (response.data) {
              this.evento = response.data
            }
          })
        },

        criarVenda() {
          this.dialogoCriaVenda = true
          this.quantidade = []
          for (let i = 1; i < 31; i++) {
            this.quantidade.push(i)
          }
        },

        fechaDialogo() {
          this.dialogoCriaVenda = false
          this.transacao.quantidadeInscricoes = null
        },

        async criarTransacao() {
          this.transacao.valor = (parseFloat(this.evento.valor.replace(',','.')) * this.transacao.quantidadeInscricoes).toFixed(2).replace('.',',')
          this.transacao.statusPagamento = 'PENDENTE'
          this.transacao.lote = this.evento.lote
          this.transacao.divulgadorId = this.lojista.id
          this.transacao.eventoId = this.evento.id
          await axios.post(baseApiUrl + 'Transacaos', this.transacao).then(response => {
            if (response.data) {
              this.idTransacao = response.data.id
            }
          })
        },

        async atualizaTransacao(callback = null) {
          this.transacao.id = this.idTransacao
          await axios.patch(baseApiUrl + 'Transacaos', this.transacao)
          .then(response => {
            if (response.data) {
              if (callback) {
                callback()
              }
            }
          })
          .catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE")
          })
        },

        async criarClienteAsaas() {
          await axios.post(baseApiUrl + 'Pagamentos/criarCliente', this.clienteAsaas)
          .then(response => {
            if (response.data) {
              this.idClienteAsaas = response.data.id
            }
          })
          .catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
          })
        },

        async pagarPix() {
          this.isLoading = true
          await this.criarTransacao()
          await this.criarClienteAsaas()
          if (this.idTransacao) {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            this.cobrancaAsaas.billingType = 'PIX'
            this.cobrancaAsaas.value = ((parseFloat(this.evento.valor.replace(',','.')) + parseFloat(this.evento.acrescimoPix.replace(',','.'))) * this.transacao.quantidadeInscricoes).toFixed(2)
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            if (this.transacao.quantidadeInscricoes == 1) {
              this.cobrancaAsaas.description = 'Referente a compra de ' + this.transacao.quantidadeInscricoes + ' ingresso para o evento ' + this.evento.nome
            } else {
              this.cobrancaAsaas.description = 'Referente a compra de ' + this.transacao.quantidadeInscricoes + ' ingressos para o evento ' + this.evento.nome
            }
            this.cobrancaAsaas.transacaoId = this.idTransacao
            this.cobrancaAsaas.empresaId = this.lojista.empresaId
            await axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaTransacao', this.cobrancaAsaas)
            .then(response => {
              if (response.data) {
                this.transacao.codigoTransacao = response.data.cobranca.invoiceUrl
                this.qrCode64 = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
                this.chaveCopiaeCola = response.data.qrCode.payload
                this.msgResultado = 'Pré-inscrição realizada com sucesso'
                this.dialogoCriaVenda = false
                this.pagamentoPix = true
                this.isLoading = false
                this.transacao.id = this.idTransacao
                this.atualizaTransacao()
                this.consultaPagamentoPix()
              }
            })
            .catch(() => {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
            })
          } else {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
          }
        },

        consultaPagamentoPix() {
          try {
            this.verificaPagamento = setInterval(function() {
              axios.post(`${baseApiUrl}Pagamentos/AsaasCobrancaConsultaTransacao`, {"transacaoId": this.idTransacao, "empresaId": this.lojista.empresaId}).then(res3 => {
                if (res3.data.status == 'RECEIVED') {
                  this.transacao.statusPagamento = "PAGO"
                  this.isLoading = true
                  this.atualizaTransacao(this.finalizaTransacao)
                  clearInterval(this.verificaPagamento)
                }
              })
            }.bind(this), 5000)
          } catch (error) {
            clearInterval(this.verificaPagamento)
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
          }
        },

        finalizaTransacao() {
          this.isLoading = false
          this.pagamentoPix = false
          this.msgResultado = 'Compra realizada com sucesso!'
          this.dialog = true
          this.buscaTransacoes()
        },

        cancelaPagamento() {
          this.transacao.statusPagamento = 'CANCELADO'
          this.atualizaTransacao()
          this.buscaTransacoes()
          clearInterval(this.verificaPagamento)
          this.pagamentoPix = false
        },
      },
    }
</script>

<style>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login100 {
    width: 100%;  
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #4A148C, #8E24AA);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;  
  }

  .wrap-login100 {
    width: 400px;
    overflow: hidden;
    background: transparent;
  }

  .login100-form {
    max-width: 90%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login100-form-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }
</style>